import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Home from "./components/Home";
import TestForm from "./components/TestForm";
import AboutUs from "./components/AboutUs";
import ServicesPage from "./components/Services";
import { PanelProvider } from "./components/PanelContext";
import { useMetaPixel } from "./hooks/useMetaPixel";
const App: React.FC = () => {
  return (
    <PanelProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/assessment" element={<TestForm />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<ServicesPage />} />
        </Routes>
      </Router>
    </PanelProvider>
  );
};

export default App;
